const getDVD = (state) => {
  if (state && state?.variantResult && state?.variantResult?.uoi_dvd) {
    return state?.variantResult?.uoi_dvd[0];
  }

  return null;
};

export { getDVD };
